import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { seriesList } from '@/mocks/series';

const featured = seriesList.filter((item) => item.featured);

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => {
      setIndex((value) => (value + 1) % featured.length);
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  if (featured.length === 0) {
    return null;
  }

  const current = featured[index];

  return (
    <section className="w-full">
      <div className="mx-auto w-full max-w-[1400px] px-4 pt-6 md:px-6 md:pt-8">
        <div className="relative h-[420px] w-full overflow-hidden rounded-2xl bg-primary-950 md:h-[560px]">
          {featured.map((item, slideIndex) => (
            <div
              key={item.id}
              className={`absolute inset-0 transition-opacity duration-700 ${
                slideIndex === index ? 'opacity-100' : 'opacity-0'
              }`}
              aria-hidden={slideIndex !== index}
            >
              <img
                src={item.heroImage}
                alt={`《${item.title}》焦点剧集海报`}
                title={`${item.title} 在线观看`}
                className={`h-full w-full object-cover object-top ${slideIndex === index ? 'animate-ken-burns' : ''}`}
              />
            </div>
          ))}

          <div className="absolute inset-0 bg-gradient-to-r from-foreground-950/90 via-foreground-950/55 to-foreground-950/10" />
          <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent" />

          <div className="relative flex h-full flex-col justify-end p-5 md:p-10">
            <span className="mb-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-accent-500/95 px-3 py-1 font-label text-xs font-semibold text-background-50">
              <i className="ri-fire-fill" />
              本周焦点推荐
            </span>

            <h2 className="font-heading text-2xl font-semibold text-background-50 md:text-4xl">{current.title}</h2>

            <div className="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2 text-sm text-background-200">
              <span className="flex items-center gap-1 font-label font-semibold text-accent-300">
                <i className="ri-star-fill" />
                {current.rating.toFixed(1)}
              </span>
              <span>{current.region}</span>
              <span>{current.year}年</span>
              <span>{current.status}</span>
              <span className="flex flex-wrap gap-1.5">
                {current.genres.map((genre) => (
                  <span key={genre} className="rounded-full bg-background-50/15 px-2 py-0.5 text-xs">
                    {genre}
                  </span>
                ))}
              </span>
            </div>

            <p className="mt-4 hidden max-w-2xl text-sm leading-relaxed text-background-200 sm:block md:line-clamp-2">
              {current.synopsis}
            </p>

            <div className="mt-6 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${current.id}`}
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-5 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-accent-600"
              >
                <i className="ri-play-fill text-lg" />
                立即观看
              </Link>
              <Link
                to={`/detail/${current.id}`}
                className="flex cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 bg-background-50/10 px-5 py-2.5 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
              >
                <i className="ri-information-line text-lg" />
                查看详情
              </Link>
            </div>
          </div>

          <button
            type="button"
            aria-label="上一部推荐"
            onClick={() => setIndex((value) => (value - 1 + featured.length) % featured.length)}
            className="absolute left-3 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-foreground-950/40 text-background-50 backdrop-blur transition-colors hover:bg-foreground-950/70 md:left-6 md:h-10 md:w-10"
          >
            <i className="ri-arrow-left-s-line text-xl" />
          </button>
          <button
            type="button"
            aria-label="下一部推荐"
            onClick={() => setIndex((value) => (value + 1) % featured.length)}
            className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 cursor-pointer items-center justify-center rounded-full bg-foreground-950/40 text-background-50 backdrop-blur transition-colors hover:bg-foreground-950/70 md:right-6 md:h-10 md:w-10"
          >
            <i className="ri-arrow-right-s-line text-xl" />
          </button>

          <div className="absolute bottom-5 right-5 flex items-center gap-2 md:bottom-8 md:right-10">
            {featured.map((item, dotIndex) => (
              <button
                key={item.id}
                type="button"
                aria-label={`查看第 ${dotIndex + 1} 部推荐`}
                onClick={() => setIndex(dotIndex)}
                className={`h-1.5 cursor-pointer rounded-full transition-all ${
                  dotIndex === index ? 'w-6 bg-accent-500' : 'w-1.5 bg-background-50/60 hover:bg-background-50'
                }`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}